import { Component, EventEmitter, Input, Output, ViewChild, ElementRef, afterNextRender, ChangeDetectionStrategy } from '@angular/core';
import { environment } from '../../environments/environment';

export type LiberroButtonWidthType =
  | 'inline'
  | 'inline-responsive'
  | 'responsive'
  | 'width-100'
  | '100-inline-desktop'
  | '100-inline-lg-desktop';

@Component({
  selector: 'liberro-button',
  templateUrl: './liberro-button.component.html',
  styleUrl: './liberro-button.component.less',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LiberroButtonComponent {
  @ViewChild('contentWrapper') public contentWrapper!: ElementRef;

  @Input() public label = '';
  @Input() public type: 'primary'|'dashed'|'link'|'text'|'default' = 'default';
  @Input() public size: 'large'|'small'|'default'	= 'default';
  @Input() public shape: 'circle'|'round' | null = environment.defaultBtnShape;
  @Input() public loading = false;
  @Input() public disabled = false;
  @Input() public danger = false;
  @Input() public customWidth = '';
  @Input() public customHeight = '';
  @Input() public customMinWidth = '';
  @Input() public widthType: LiberroButtonWidthType | null = null;
  @Input() public dataCy = '';
  @Input() public buttonType: 'button' | 'submit' = 'button';

  @Output() private btnClick = new EventEmitter<void>();

  public hasContent = false;

  public constructor() {
    afterNextRender(() => {
      this.hasContent = this.contentWrapper?.nativeElement?.children.length > 0;
    });
  }

  public onBtnClick(): void {
    this.btnClick.emit();
  }
}
